import React from "react";

import { IconName } from "../../../styles/icons/icons";
import { LocationShape } from "../../../types";
import { Icon } from "../../content";
import { Box, Column, Stack } from "../../layout";
import { Link } from "../../typography";

export type MobileNavbarItemProps = {
  to: string | LocationShape;
  iconName: IconName;
  onClick?: React.MouseEventHandler;
  label?: string;
  isActive?: boolean;
  showLabel?: boolean;
  disabled?: boolean;
};

export default function MobileNavbarItem({
  onClick,
  label,
  iconName,
  isActive = false,
  showLabel = true,
  disabled = false,
  to
}: MobileNavbarItemProps) {
  return (
    <Column alignX="center">
      <Link
        to={to}
        disabled={disabled}
        onClick={onClick}
        size="xsmall"
        tone={isActive ? "primary" : "neutral"}
        emphasis={isActive ? "high" : "medium"}
        disableInteractiveStyles
      >
        <Box
          display="flex"
          paddingY="12"
          alignItems="center"
          width="100%"
          border="none"
          outline="none"
          background="transparent"
        >
          <Stack space="medium" align="center">
            <Icon accessibilityLabel={null} iconName={iconName} size="xlarge" />
            {label && showLabel && <Box>{label}</Box>}
          </Stack>
        </Box>
      </Link>
    </Column>
  );
}
